import { START_PLAYING, STOP_PLAYING } from './stimulusButtonActions';

const defaultState = {
    isPlaying: false,
};

const stimulusButtonReducer = (state = defaultState, action) => {
    switch (action.type) {
    case START_PLAYING:
        return {
            ...state,
            isPlaying: true,
        };
    case STOP_PLAYING:
        return {
            ...state,
            isPlaying: false,
        };
    default:
        return state;
    }
};

export default stimulusButtonReducer;
